import { getFlagColor } from '@cheqroom/api';
import { FlagAlt, FlagAltFilled } from '@cheqroom/icons';
import { FC } from 'react';

import { Icon } from '../../Icon';
import { Info } from '../../Info';
import { useItemInfoContext } from '../ItemInfo.context';

interface Props {
	showColor?: boolean;
	flag?: string;
}

export const Flag: FC<Props> = ({ showColor = false, flag: flagIdOverride }) => {
	const { item, workspace } = useItemInfoContext();

	const flagId = flagIdOverride ?? item.flag;
	const flag = workspace?.itemFlags?.find((flag) => flag.id === flagId);
	if (!flag) return null;

	const FlagIcon = showColor ? FlagAltFilled : FlagAlt;

	return (
		<Info
			icon={
				<Icon
					source={FlagIcon}
					size="small"
					color={showColor ? getFlagColor(flag.color) : undefined}
					className={showColor ? undefined : 'text-gray-400'}
				/>
			}
			text={flag.name}
		/>
	);
};
